import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Email'),"outlined":"","hide-details":"auto","rules":_vm.rules},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }